// Frontend counterpart of api/utils/safeUrl.js.
//
// The API validates every URL on write, but rows stored before that validation
// existed were accepted by an unanchored regex, and a URL can also reach a sink
// through a response the API does not own (e.g. presigned storage links). So
// every URL is validated again here, at the point where it becomes an
// `<iframe src>` or an `<a href>` — the two sinks where a `javascript:` URL
// executes in the portal's own origin.

const ALLOWED_PROTOCOLS = ['http:', 'https:'];

export const isHttpUrl = (value) => {
  if (typeof value !== 'string' || value.trim() === '') return false;

  let url;
  try {
    url = new URL(value.trim());
  } catch (error) {
    return false;
  }

  if (!ALLOWED_PROTOCOLS.includes(url.protocol)) return false;
  // https://user:pass@host renders as the host in most UIs: a phishing vector.
  if (url.username || url.password) return false;

  return !!url.hostname;
};

/**
 * Returns the URL only when it is a plain http(s) URL, and `undefined`
 * otherwise, so React drops the attribute entirely instead of rendering
 * `src="javascript:..."`.
 */
export const safeUrl = (value) => (isHttpUrl(value) ? value.trim() : undefined);

export default safeUrl;
